import { create } from 'zustand';
import type { AppState, CrispSession, PlayerData } from '@/types/index';

export const useStore = create<AppState>((set) => ({
  // Session
  session: null,
  token: null,
  playerToken: null,
  setSession: (session: CrispSession, token: string) =>
    set({ session, token }),
  setPlayerToken: (token: string | null) => set({ playerToken: token }),
  clearSession: () => set({ session: null, token: null, playerToken: null }),

  // Player data
  currentPlayer: null,
  setCurrentPlayer: (player: PlayerData | null) =>
    set({ currentPlayer: player }),
  loadingPlayer: false,
  setLoadingPlayer: (loading: boolean) => set({ loadingPlayer: loading }),

  // UI state
  sidebarOpen: true,
  setSidebarOpen: (open: boolean) => set({ sidebarOpen: open }),
}));
